export default {
  methods: {
    orderAudiFirst(items) {
      // id=Audi is always the first element
      // let audi = items.find(x => x.id === 'Audi');
      
      // sort items by id
      items.sort((a, b) => a.id.localeCompare(b.id));
      
      // if (audi) {
      //   items.splice(items.indexOf(audi), 1);
      //   items.unshift(audi);
      // }
      return items; 
    },

    getSortedBrands(brands, selected) {
      let items = JSON.parse(JSON.stringify(brands));
      let audi = items.find(x => x.id === 'Audi');

      if (audi) {
        items.splice(items.indexOf(audi), 1);
        items.unshift(audi);
      }

      return items.filter(x => selected.includes(x.id));
    }, 
    
    getSortedBrandIds(brandIds) {
      // id=Audi is always the first element
      let brands = JSON.parse(JSON.stringify(brandIds));
      try
      {
        let audi = brands.find(x => x === 'Audi');
        
        // sort items by id
        brands.sort((a, b) => a.localeCompare(b));
        
        if (audi) {
          brands.splice(brands.indexOf(audi), 1);
          brands.unshift(audi);
        }
      }
      catch (e) {
        console.error(e);
      }

      return brands;
    },
    
    multiplyPreserveDecimalPlaces(number) {
      // Convert the number to a string to work with its decimal part
      const numberStr = number.toString();
      
      // Find the index of the decimal point
      const decimalIndex = numberStr.indexOf('.');
      
      // If there is a decimal point, determine the number of digits after it
      let decimalPlaces = 0;
      if (decimalIndex !== -1) {
        decimalPlaces = numberStr.length - decimalIndex - 3;
        if (decimalPlaces < 0) {
          decimalPlaces = 0;
        }
      }
      
      // Multiply the number by 100
      let multiplied = number * 100;
      
      // Convert the result back to a string with the original number of decimal places
      const result = multiplied.toFixed(decimalPlaces);
      
      // Convert the string back to a number if needed, or return as string for exact representation
      // Returning as a string to preserve trailing zeroes
      return result;
    }
  }
};
